var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['alert', _vm.typeClass]},[_c('div',{staticClass:"alert__icon"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"alert__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }